import { BaseService } from "./BaseService";
import { ApiKey, ErrorResponse, BuildxConfig } from "../types/index";

/**
 * API Keys service for Buildx
 * Handles API key management
 * 
 * @example
 * ```typescript
 * const apiKeys = buildx.apiKeys();
 * 
 * // List API keys
 * const keys = await apiKeys.list();
 * 
 * // Get API key by ID
 * const key = await apiKeys.get('key-id');
 * 
 * // Get API key secret
 * const secret = await apiKeys.getSecret('key-id');
 * ```
 */
export class ApiKeys {
	private baseService: BaseService;

	constructor(config: BuildxConfig) {
		this.baseService = new BaseService(config);
	}

	updateConfig(config: BuildxConfig): void {
		this.baseService.updateConfig(config);
	}

	/**
	 * List all API keys
	 */
	async list(organizationId?: string): Promise<ApiKey[] | ErrorResponse> {
		const url = organizationId
			? this.baseService.buildOrgUrl(organizationId, "/auth/api-keys")
			: "/auth/api-keys";
		return await this.baseService.get(url);
	}

	/**
	 * Get API key by ID
	 */
	async get(apiKeyId: string, organizationId?: string): Promise<ApiKey | ErrorResponse> {
		const url = organizationId
			? this.baseService.buildOrgUrl(organizationId, `/auth/api-key/${apiKeyId}`)
			: `/auth/api-key/${apiKeyId}`;
		return await this.baseService.get(url);
	}

	/**
	 * Get API key secret
	 */
	async getSecret(apiKeyId: string, organizationId?: string): Promise<any | ErrorResponse> {
		const url = organizationId
			? this.baseService.buildOrgUrl(organizationId, `/auth/api-key/${apiKeyId}/secret`)
			: `/auth/api-key/${apiKeyId}/secret`;
		return await this.baseService.get(url);
	}
} 